import { isStaging } from "../../helper/environment.js";

// TODO: delete window variable when gtag initialization is removed from asset-service
window.gtagMerkurActive = true;

if (typeof window.gtag === "function") {
    const script = document.currentScript;
    const { measurementId } = script.dataset;
    const config = {
        "send_page_view": false,
        "server_container_url": window.location.origin + "/tag/"
    }
    if (isStaging) {
        config["debug_mode"] = true;
    }
    gtag("js", new Date());
    gtag("config", measurementId, config);
}
